module.exports = __webpack_public_path__ + "static/media/04_plantilla_combo_rectangular_marco_comida_21.6d71e8e1.png";